import {
  buildDeserializer,
  buildSerializer,
  SerializeMap,
} from "lib/serializerUtils";

const nlisHoldingDeviceSerializeMap: SerializeMap<NlisHoldingDevice> = {
  id: "id",
  nlisId: "nlis_id",
  eid: "eid",
  vendorPic: "vendor_pic",
  nvdWaybill: "nvd_waybill",
  saleDate: "sale_date",
  species: "species",
  saleyardName: "saleyard_name",
  description: "description",
  lastModified: "last_modified",
  created: "created",
};

const nlisHoldingSerializeMap: SerializeMap<NlisHolding> = {
  id: "id",
  lastSynced: "last_synced",
  status: "status",
  devices: nlisHoldingDeviceSerializeMap,
};

export const serializeNlisHolding = buildSerializer<NlisHolding>(
  nlisHoldingSerializeMap,
  "NlisHolding",
);

export const deserializeNlisHolding = buildDeserializer<NlisHolding>(
  nlisHoldingSerializeMap,
  "NlisHolding",
);
